Core.Account = {
    form: function () {

        Core.Account.Cache = {
            $validationForm: $('.form-validation'),
            $ajaxAccountForm: $('#account-form'),
            $formSubmit: $('#form-submit'),
            $loginShowPassword: $('#showPassword'),
            $regShowPassword: $('#reg-showPassword'),
            $accShowPassword: $('#acc-showPassword'),
            $loginPasswordInp: $('div.login-form').find('input[type="password"]'),
            $regPasswordInp: $('div.register-login-details').find('input[type="password"]'),
            $accPasswordInp: $('section#edit-details').find('input[type="password"]'),
            $printButton: $('#print')
        };

        Core.Account.Cache.$validationForm.each(function () {
            var isSms = function() {
                var $mfaMethod = $('#mfaMethod');
                return $mfaMethod.length && $mfaMethod.val().toLowerCase() === 'sms';
            };

            $(this).validate({
                focusInvalid: false,
                invalidHandler: function (form, validator) {

                    if (!validator.numberOfInvalids())
                        return;

                    $("div.validation-summary-errors").html('');
                    $('html, body').animate({
                        scrollTop: $(validator.errorList[0].element.parentElement).offset().top - 30
                    }, 300);
                },
                rules: {
                    MobilePhone: {
                        required: {
                            depends: isSms
                        },
                        mobileau: {
                            depends: isSms
                        },
                    }
                },
                messages: {
                    MobilePhone: {
                        required: 'Please enter a mobile number for SMS verification'
                    }
                }
            });
        });

        var _self = this;

        _self.Cache.$ajaxAccountForm.on('submit', function (e) {
            e.preventDefault();

            if (_self.Cache.$ajaxAccountForm.valid()) {
                $.ajax({
                    url: _self.Cache.$ajaxAccountForm.attr('action'),
                    data: _self.Cache.$ajaxAccountForm.serialize(),
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        var _$validationMessage = Core.Account.Cache.$ajaxAccountForm.find('.frm-validation-msg');
                        _$validationMessage.hide();

                        if (data.Success) {
                            window.location.href = data.SuccessUrl;
                        }
                        else {
                            _$validationMessage.html('<div class="error-msg">' + data.ErrorMessage + '</div>').show();
                        }
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        //todo: do something
                    }
                });
            }
        });

        if (Core.Account.Cache.$loginShowPassword.length > 0) {
            this.handleShowPwdClick(Core.Account.Cache.$loginShowPassword, Core.Account.Cache.$loginPasswordInp);
        }

        if (Core.Account.Cache.$regShowPassword.length > 0) {
            this.handleShowPwdClick(Core.Account.Cache.$regShowPassword, Core.Account.Cache.$regPasswordInp);
        }

        if (Core.Account.Cache.$accShowPassword.length > 0) {
            this.handleShowPwdClick(Core.Account.Cache.$accShowPassword, Core.Account.Cache.$accPasswordInp);
        }
    },
    handleShowPwdClick: function($checkBox, $input) {
        Core.Account.checkShowPassword($checkBox, $input);
        $checkBox.unbind("click");

        $checkBox.on('click', function (e) {
            Core.Account.showPassword($(this), $input, this.checked);
        });
    },
    showPassword: function ($chekBox, $input, doShow) {
        doShow = doShow == null || undefined ? false : doShow; //set default to false/hide

        if (doShow) {
            $input.prop('type', 'text');
            $chekBox.addClass('showing');
        } else {
            $input.prop('type', 'password');
            $chekBox.removeClass('showing');
        }

        $.uniform.update();
    },
    //check password input on load
    checkShowPassword: function ($chekBox, $input) {
        //check if checkbox is checked
        $chekBox.prop('checked') ?
            Core.Account.showPassword($chekBox, $input, true) :
            Core.Account.showPassword($chekBox, $input, false);
    },
    myAccount: function () {
        $('#promotions').on('click', function (e) {
            var _checked = $(event.target).parent('span.checked').length > 0;

            $.ajax({
                url: '/account/updatepromotions/?enable=' + _checked,
                type: 'POST',
                success: function (data) {
                    var _message = '';

                    if (data) {
                        _message = '<strong>Your preferences have been updated</strong>';
                    } else {
                        _message = '<strong>Sorry, we could not update your preferences</strong>';
                    }

                    $('#result').html(_message);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    //todo: do something
                }
            });
        });
    },
    dataTable: function (dataUrl, firstColumnTitle, hideTotalColumn) {

        function detailInit(e) {
            var div = $("<div class='details'/>").appendTo(e.detailCell);

            var object = {};
            object.ClientName = e.data.ClientName;
            object.Comments = e.data.Comments;
            object.Date = e.data.Date;
            object.FundingType = e.data.FundingType;
            object.GST = e.data.GST;
            object.Image = e.data.Image;
            object.QuoteID = e.data.QuoteID;
            object.PrimaryKeyId = e.data.PrimaryKeyId;

            object.SubTotal = e.data.SubTotal;
            object.Total = e.data.Total;
            object.OrderTotal = e.data.OrderTotal;

            object.OrderDetails = [];

            for (var x = 0; x < e.data.OrderDetails.length; x++) {
                object.OrderDetails.push(e.data.OrderDetails[x]);
            }

            Handlebars.registerHelper('breaklines', function (text) {
                text = Handlebars.Utils.escapeExpression(text);
                text = text.replace(/(\r\n|\n|\r)/gm, '<br>');
                return new Handlebars.SafeString(text);
            });

            var template = Handlebars.compile($('#tplOrderDetails').html());
            var html = template(object);
            $(div).html(html);

            $('#print-rental, #print-trial').on('click', function (e) {
                e.preventDefault();
                $(this).closest('.k-detail-row').addClass('active');
                $(this).closest('.k-detail-row').prev('.k-master-row').addClass('active');
                $(this).closest('.my-details-container').addClass('print');
                window.print();
                $(this).closest('.k-detail-row').removeClass('active');
                $(this).closest('.k-detail-row').prev('.k-master-row').removeClass('active');
                $(this).closest('.my-details-container').removeClass('print');
            });

            $('.add-to-cart').on('click', function (e) {
                e.preventDefault();
                var _$this = $(this);
                var quoteId = _$this.data('id');

                if (quoteId.length > 0) {
                    Core.ShowPageLoading();
                    $.get('/account/requote?quoteId=' + quoteId).
                    success(function (data, status, headers, config) {

                        Core.HidePageLoading();
                        Core.Engine.getCartSummary();

                        var _width = Core.Config.CartNotification.Width,
                           _height = Core.Config.CartNotification.Height;

                        if (Core.IsMobile()) {
                            _width = Core.Cache.$window.width();
                        }

                        //check which items have been successful
                        var _successfulItems = [];
                        for (var x = 0; x < data.length; x++) {
                            //if (data[x].WasSuccess) {
                            _successfulItems.push(data[x]);
                            //}
                        }

                        if (_successfulItems.length > 0) {
                            //increase height of window if more than 2 items
                            if (_successfulItems.length > 2) {
                                _height = _height + (_successfulItems.length - 2) * 35;
                            }

                            Core.RenderTemplate('#tpl-cart-notification', _successfulItems, $('#cart-notification-content'));

                            var _$addToCartWindow = $('#cart-notification');

                            _$addToCartWindow = _$addToCartWindow.kendoWindow({
                                width: _width, height: _height, visible: false, iframe: false, modal: true, resizable: false, pinned: true, draggable: false, appendTo: '#page-wrap', animation: false
                            });

                            _$addToCartWindow.data("kendoWindow").center().open();

                            $(".k-overlay").on('click', function () {
                                _$addToCartWindow.data("kendoWindow").close();
                            });

                            $(".k-window-action > span.k-i-close, .cart-notification-buttons > a.k-i-close").on('click', function (e) {
                                e.preventDefault();
                                _$addToCartWindow.data("kendoWindow").close();
                            });
                        }
                        else {
                            //todo: do something when no items have been added
                            alert('Sorry, that was a problem adding items to your cart');
                        }

                    }).error(function (data, status, headers, config) {
                        //todo: do something
                    });
                }
            });
        }

        var _$grid = $(".grid"),
            _$pagerNav = $('.k-pager-nav'),
            _$columns = [];

        if (!hideTotalColumn) {
            _$columns = [
                { field: "QuoteID", title: firstColumnTitle },
                { field: "Date", type: "date", format: "{0:dd/MM/yyyy}" },
                { field: "ClientName", title: "Client Name" },
                { field: "FundingType", title: "Funding" },
                { field: "Total", title: "Total", type: "number", format: "{0:c}" }
            ];
        } else {
            _$columns = [
                { field: "QuoteID", title: firstColumnTitle },
                { field: "Date", type: "date", format: "{0:dd/MM/yyyy}" },
                { field: "ClientName", title: "Client Name" },
                { field: "FundingType", title: "Funding" }
            ];
        }

        _$grid.kendoGrid({
            dataSource: {
                transport: {
                    read: {
                        url: dataUrl,
                        dataType: "Json",
                        contentType: "application/json; charset=utf-8",
                        method: "GET"
                    }
                },
                serverPaging: false,
                serverSorting: false,
                sort: { field: "Date", dir: "desc" },
                schema: {
                    parse: function (response) {
                        $.each(response, function (idx, elem) {
                            if (elem.Date && typeof elem.Date === "string") {
                                elem.Date = kendo.parseDate(elem.Date, "dd-MMM-yyyy");
                            }
                        });
                        return response;
                    }
                },
                requestStart: Core.ShowPageLoading()
            },
            sortable: true,
            pageable: {
                pageSize: 10,
                messages: {
                    first: "",
                    last: "",
                    next: "next",
                    previous: "previous"
                },
                info: false
            },
            detailInit: detailInit,
            dataBound: function () {
                if (this.dataSource.total() === 0) {
                    _$grid.hide();
                } else {
                    _$grid.show();

                    //this.expandRow(this.tbody.find("tr.k-master-row").first());

                    if (this.dataSource.total() > 10) {
                        _$pagerNav.find('span.k-i-arrow-w').text('<');
                        _$pagerNav.find('span.k-i-arrow-e').text('>');
                        $('.k-pager-wrap').show();
                    }

                    _$grid.find('.k-grid-header-wrap > table').addClass('responsiveTable');
                    _$grid.find('.k-master-row td:nth-child(2)').addClass('quote-id');
                    _$grid.find('.k-master-row td:nth-child(3)').addClass('date');
                    _$grid.find('.k-master-row td:nth-child(4)').addClass('client-name');
                    _$grid.find('.k-master-row td:nth-child(5)').addClass('funding-type');
                    _$grid.find('.k-master-row td:nth-child(6)').addClass('total');
                    $('.k-minus').closest('tr').addClass('active');
                }

                Core.HidePageLoading();

                $('#my-quote .k-icon').on('click', function () {
                    $(this).closest('.k-master-row').toggleClass('active');
                });
            },
            columns: _$columns
        });
    }
}
